"use client";

import { EyeOff, RotateCcw } from "lucide-react";

interface DismissRestoreButtonProps {
  isDismissed: boolean;
  onDismiss: () => void;
  onRestore: () => void;
  variant: "card" | "detail";
}

export function DismissRestoreButton({
  isDismissed,
  onDismiss,
  onRestore,
  variant,
}: DismissRestoreButtonProps) {
  if (variant === "detail") {
    return isDismissed ? (
      <button
        type="button"
        onClick={onRestore}
        className="ml-auto flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium bg-zinc-100 text-zinc-600 hover:bg-zinc-200 transition-colors"
      >
        <RotateCcw size={12} />
        Return to list
      </button>
    ) : (
      <button
        type="button"
        onClick={onDismiss}
        className="ml-auto flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium bg-zinc-100 text-zinc-600 hover:bg-zinc-200 transition-colors"
      >
        <EyeOff size={12} />
        Mark as reviewed
      </button>
    );
  }

  // variant === "card"
  return isDismissed ? (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onRestore();
      }}
      className="pointer-events-auto p-1 rounded-md border border-zinc-200 bg-zinc-50
        hover:border-zinc-400 hover:bg-zinc-100 text-zinc-400 hover:text-zinc-600
        transition-colors flex items-center gap-1 text-xs"
    >
      <RotateCcw size={14} />
      <span>Restore</span>
    </button>
  ) : (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onDismiss();
      }}
      className="pointer-events-auto ml-1 p-1 rounded-md border border-zinc-200 bg-zinc-50
        hover:border-zinc-400 hover:bg-zinc-100 text-zinc-400 hover:text-zinc-600
        transition-colors flex items-center gap-1 text-xs"
    >
      <EyeOff size={14} />
      <span>Reviewed</span>
    </button>
  );
}
